<app-blog-detail *ngIf="!isLoggedIn"></app-blog-detail>

<full-layout *ngIf="isLoggedIn">
	<app-blog-detail-inner></app-blog-detail-inner>
</full-layout>